import { UserManager, User, UserManagerSettings } from "oidc-client";

export class AuthService {
  private userManager: UserManager;
  private signInCallbackFallbackRoute: string;

  public onUserUpdated?: (user?: User|false) => void;

  public constructor(oidcSettings: UserManagerSettings, signInCallbackFallbackRoute: string) {
    this.userManager = new UserManager(oidcSettings)
    this.signInCallbackFallbackRoute = signInCallbackFallbackRoute
    this.userManager.events.addUserLoaded(user => this.onUserUpdated?.call(this, user))
    this.userManager.events.addUserUnloaded(() => this.onUserUpdated?.call(this, false))
  }

  public async initiate(): Promise<void> {
    const user = await this.userManager.getUser();
    if (user?.expired) {
      try {
        const user = await this.userManager.signinSilent();
        this.onUserUpdated?.call(this, user);
      }
      catch {
        this.onUserUpdated?.call(this, false);
      }
    } else {
      this.onUserUpdated?.call(this, user || false);
    }
  }

  public async startSignIn(returnUrl: string): Promise<void> {
    await this.userManager.signinRedirect({data: { returnUrl }});
  }

  public async completeSignIn(): Promise<string> {
    try
    {
      const oidcUser = await this.userManager.signinRedirectCallback();
      return oidcUser?.state?.returnUrl ?? this.signInCallbackFallbackRoute;
    }
    catch
    {
      return this.signInCallbackFallbackRoute;
    }
  }

  public async startSignOut(): Promise<void> {
    await this.userManager.signoutRedirect();
  }

  public async completeRefresh(): Promise<void> {
    await this.userManager.signinSilentCallback();
  }
}
